import React, { useContext } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Files from 'src/apps/Initiative/apps/Files'
import HomeLayout1 from 'src/components/Initiative/HomeLayout1'
import ScrollView from 'src/components/utils/ScrollView'
import SessionLayout1 from 'src/components/Schedule/SessionLayout1'
import { InitiativeHierarchyContext, withInitiativeHierarchyProvider }
   from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeScheduleSession = () => {
   const match = useRouteMatch()
   const { initiative, initiativeLoading } = useContext(InitiativeHierarchyContext)
   if (initiativeLoading) {
      return null
   }

   return (
      <ScrollView width="100%" height="100%" scroll="on">
         <SessionLayout1
            baseUrl={match.url}>
            <Switch>
               <Route
                  exact
                  path={match.url}
                  render={() => (
                     <HomeLayout1
                        initiative={initiative}
                     />
                  )}
               />
               <Route path={`${match.url}/files`} component={Files} />
            </Switch>
         </SessionLayout1>
      </ScrollView>
   )
}

export default withInitiativeHierarchyProvider({ slugParam: 'sessionSlug' })(InitiativeScheduleSession)
